import { DI } from '@intigral/constant/config/DIContainer';
import { Container } from '../../../DIContainer';
import { GetBadgesUseCase } from './GetBadgesUseCase';
import { GetQuestsUseCase } from './GetQuestsUseCase';

export const initializeRewardUseCases = (container: Container) => {
    container.register(DI.USECASES.IGetBadgesUseCase, {
        useClass: GetBadgesUseCase,
    });
    container.register(DI.USECASES.IGetQuestsUseCase, {
        useClass: GetQuestsUseCase,
    });
};
